import "./ActionButtons.css";

{
  /* {adjustmentType === "Actual Count" ? (
                    <div className="row mt-4">
                      <div className="col-md-4">
                        <label className="form-label fw-bold">
                          Actual Count Date
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          value={actualCountDate}
                          max={new Date().toISOString().split("T")[0]} // <-- Disable future dates
                          onChange={(e) =>
                            this.setState({ actualCountDate: e.target.value })
                          }
                          required
                        />
                      </div>
                    </div>
                  ) : (
                    <></>
                  )} */
}
const ActionButtons = ({
  onCancel,
  onSubmit,
  onPartiallySave,
  showSubmit = true,
  showPartiallySave = false,
  cancelText = "Cancel",
  submitText = "Submit",
  partiallySaveText = "Partially Save",
  isLoading = false,
}) => {
  return (
    <div className="mt-4 d-flex justify-content-center gap-3">
      <button
        type="button"
        className="btn btn-cancel px-4 py-2 rounded-3 fw-medium transition-all"
        onClick={onCancel}
        disabled={isLoading}
      >
        {cancelText}
      </button>

      {showSubmit && (
        <button
          onClick={onSubmit}
          className="btn btn-submit px-4 py-2 rounded-3 fw-medium transition-all"
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Processing...
            </>
          ) : (
            <>
              <i className="bi bi-check-circle me-2"></i>
              {submitText}
            </>
          )}
        </button>
      )}

      {showPartiallySave && (
        <button
          onClick={onPartiallySave}
          className="btn btn-warning px-4 py-2 rounded-3 fw-medium transition-all"
          disabled={isLoading}
        >
          <i className="bi bi-save me-2"></i>
          {partiallySaveText}
        </button>
      )}
    </div>
  );
};

export default ActionButtons;
